<template>
  <div class="view-list-2">
    <!--      <Button @click="getCompStatisticGen()">re-generate</Button>-->
    <!--      <button @click="getCompStatistic()">default-load</button>-->
    <div class="train-comp">
      <div id="main" ref="chartRef"
           style="width: 100%; height: 800px; margin-top: 20px "/>
      <a-radio-group
          v-model="teamType"
          @change="handleChangeTeam"
          style="font-size: 18px;margin-bottom: 10px;"
      >
        <a-radio-button value="men" style="margin:10px">男队</a-radio-button>
        <a-radio-button value="women" style="margin:10px">女队</a-radio-button>
<!--        <a-radio-button value="youth_men" style="margin:10px">男青</a-radio-button>-->
<!--        <a-radio-button value="youth_women" style="margin:10px">女青</a-radio-button>-->

      </a-radio-group>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getCompTrainingTime, getCompTrainingTimeGen} from "@/api";

export default {
  name: 'TrainingAnalysis',
  data() {
    return {
      teamType: 'men',
      playerCompDays:[],
      rawData:[[], [], []], // 顺序：国际比赛（原有）、国内比赛（新增）、训练日（原有）
      players:[],
      selectedTeamData :[],
      allTeamData: {"men":[],"women":[],"youth_men":[],"youth_women":[]}
    };
  },
  created() {
    const userInfo = this.$store.state.userInfo;
    if (!userInfo) {
      this.$router.push('/login');
    }
    this.getCompStatistic().then(r => {
          // # parse team
          console.log('r=',r)
          let myChart = echarts.init(this.$refs.chartRef);
          this.setChartOption(myChart, this.chartOption);
        }
    )

  },
  mounted() {
    let myChart = echarts.init(this.$refs.chartRef);
    this.setChartOption(myChart, this.chartOption);
  },
  computed: {
    totalData() {
      let totalData = [];
      for (let i = 0; i < this.rawData[0].length; ++i) {
        let sum = 0;
        for (let j = 0; j < this.rawData.length; ++j) {
          sum += this.rawData[j][i];
        }
        totalData.push(sum);
      }
      return totalData;
    },
    series() {
      return [
        '国际比赛时间', // 原有：仅修改名称更清晰，不影响逻辑
        '国内比赛时间', // 新增：国内比赛系列
        '可训练时间',  // 原有：保持不变
      ].map((name, sid) => {
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '60%',
          label: {
            show: true,
            fontSize: 16,
            formatter: (params) => Math.round(params.value/365 * 1000) / 10 + '%'
          },
          data: this.rawData[sid].map((d) =>{
            return {
              value: d,
            }
          })
        };
      });
    },
    chartOption() {
      return {
        color:['#00375B', '#45a9dc', '#d5e3ef'], // 原有配色保留，新增国内比赛颜色（橙色）
        legend: {
          selectedMode: false,
          textStyle:{
            fontSize: 18
          }
        },
        grid: {
          left: 100,
          right: 100,
          top: 50,
          bottom: 50
        },
        yAxis: {
          type: 'value',
          max: 365,
          min: 0,
          axisLabel:{
            fontSize: 16
          }
        },
        xAxis: {
          type: 'category',
          data: this.players,
          axisLabel:{
            fontSize: 18
          }

        },
        label:{
          textStyle:{
            fontSize: 14
          }
        },
        series: this.series,
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let result = '';
            // 1. 获取当前hover的球员姓名（x轴标签文本）
            const currentPlayerName = params[0]?.name;
            // 2. 从当前选中的团队数据中，通过姓名精准匹配球员
            const currentPlayer = this.selectedTeamData.find(
                player => player?.playerName === currentPlayerName
            );

            // 显示天数统计（原有逻辑）
            params.forEach((item) => {
              result += item.seriesName + '：' + item.value + '天<br/>';
            });
            result += "——————<br/>";

            // 3. 验证是否匹配到球员数据（避免undefined报错）
            if (!currentPlayer) {
              result += "数据加载中...";
              return result;
            }

            // 显示国际赛事
            const intlMatches = currentPlayer.ptcMeta || [];
            result += "国际赛事：<br/>";
            if (intlMatches.length > 0) {
              intlMatches.forEach(match => {
                result += `${match.matchNameCn}（${match.days}天）<br/>`;
              });
            } else {
              result += "无<br/>";
            }

            // 显示国内赛事（核心修复：用匹配到的球员数据）
            const cnMatches = currentPlayer.ptcMetaCN || [];
            result += "国内赛事：<br/>";
            if (cnMatches.length > 0) {
              cnMatches.forEach(match => {
                result += `${match.matchNameCn}（${match.days}天）<br/>`;
              });
            } else {
              result += "无<br/>";
            }

            return result;
          }
        }
      };
    }
  },
  methods: {
    handleChangeTeam(e) {
      const team = e.target.value;

      // 从所有数据中过滤当前团队
      const teamData = this.parse_into_teams(this.allTeamData, team);

      // 更新数据
      this.rawData = [
        teamData.map(r => r.compDays),
        teamData.map(r => r.compDaysInCN || 0),
        teamData.map(r => 365 - r.compDays - (r.compDaysInCN || 0))
      ];
      this.players = teamData.map(r => r.playerName);
      this.selectedTeamData = teamData; // 关键：更新选中的团队数据

      // 重新渲染图表
      const myChart = echarts.init(this.$refs.chartRef);
      this.setChartOption(myChart, this.chartOption);
    },
    setChartOption(chartRef, option) {
      chartRef.setOption(option);
    },
    async getCompStatistic() {
      const response = await getCompTrainingTime('2025-01-01','2025-12-31')
      if(response.status === 200) {
        if(response.data.success) {
          let teamData = this.parse_into_teams(response.data.data,this.teamType)
          // 【数据初始化：新增国内比赛字段】
          this.rawData = [
            teamData.map(r=>r.compDays),
            teamData.map(r=>r.compDaysInCN || 0),
            teamData.map(r=>365 - r.compDays - (r.compDaysInCN || 0))
          ]
          this.players = teamData.map(r=>r.playerName)
          this.allTeamData = response.data.data
          this.selectedTeamData = teamData
          return teamData
        }
      }

    },
    async getCompStatisticGen() {
      const response = await getCompTrainingTimeGen('2025-01-01','2025-12-31')
      if(response.status === 200) {
        if(response.data.success) {
          let teamData = this.parse_into_teams(response.data.data,this.teamType)
          // 【数据初始化：新增国内比赛字段】
          this.rawData = [
            teamData.map(r=>r.compDays),
            teamData.map(r=>r.compDaysInCN || 0),
            teamData.map(r=>365 - r.compDays - (r.compDaysInCN || 0))
          ]
          this.players = teamData.map(r=>r.playerName)
          this.allTeamData = response.data.data
          this.selectedTeamData = teamData
          return teamData
        }
      }
    },
    parse_into_teams(all_player_data, team) {
      return all_player_data.filter(p=>p.playerTeam === team)
    }
  },
};
</script>
<style scoped lang="less">
.view-list-2{
  height: calc(100% - 140px);
  width: calc(100% - 20px);
  background-color: #FFFFFF;
  .train-comp{
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
  }
}
/deep/.ant-radio-button-wrapper:hover {
  color: #003b63!important;
}
/deep/.ant-radio-button-wrapper-checked {
  color: #003b63!important;
  border-color: #003b63!important;
}
</style>
